import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedStatus {
    
    public readonly key = 'UnassignedStatus';
  }

export type Status = Async<string[]> | UnassignedStatus;

type MatchStatusOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (status: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (status: []) => TReturn;
  };

export const isLoading = (status: Status): status is Loading<string[]> =>
    status.key === 'Loading';

export const isLoaded = (status: Status): status is Loaded<string[]> => status.key === 'Loaded';
export const isUnassignedStatus = (status: Status): status is UnassignedStatus => status.key === 'UnassignedStatus';

export const matchStatus = <TReturn>(options: MatchStatusOptions<TReturn>) => (
    status: Status
  ) => {
  
    switch (status.key) {
      case 'UnassignedStatus':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(status.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  